import React from 'react'

interface NavbarCloseIconProps {
  size?: number
  color?: string
  className?: string
  showBackground?: boolean
}

const NavbarCloseIcon: React.FC<NavbarCloseIconProps> = ({
  size = 32,
  color = 'white',
  className,
  showBackground = true,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      className={className}
    >
      <g clipPath="url(#clip0_437_15177)">
        {/* 背景圆形 - 可选 */}
        {showBackground && (
          <rect width="32" height="32" rx="16" fill="rgba(0, 0, 0, 0.2)" />
        )}
        {/* X形状的关闭图标 */}
        <path
          d="M19.955 21.0157C20.2479 21.3085 20.7227 21.3086 21.0156 21.0157C21.3084 20.7228 21.3084 20.248 21.0156 19.9551L17.3027 16.2432L21.0156 12.5303C21.3084 12.2374 21.3084 11.7627 21.0156 11.4698C20.7227 11.1769 20.2479 11.177 19.955 11.4698L16.2421 15.1827L12.5302 11.4698C12.2373 11.1769 11.7626 11.177 11.4697 11.4698C11.1768 11.7627 11.1768 12.2374 11.4697 12.5303L15.1816 16.2432L11.4697 19.9551C11.1768 20.248 11.1768 20.7228 11.4697 21.0157C11.7626 21.3086 12.2373 21.3086 12.5302 21.0157L16.2421 17.3038L19.955 21.0157Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_437_15177">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default NavbarCloseIcon
